import React from 'react'
import moment from 'moment'
import constants from '../assets/constants'
import RowComponent from './CardRiepilogoRow'
import { Col, Row } from 'antd'
import _ from 'lodash'
import 'moment/locale/it'

const RiepilogoCardCosti = (props) => {
  const libero = _.get(props.formValue, 'libero')
  const permanenza = _.get(
    _.find(
      constants.permanenze,
      (item) => item.value === _.get(props.formValue, 'permanenza', '')
    ),
    'label'
  )
  const canone = _.toString(_.get(props.formValue, 'canone', '')).replace(
    /\B(?=(\d{3})+(?!\d))/g,
    '.'
  )
  const caparre = _.get(
    _.find(
      constants.caparre,
      (item) => item.value === _.get(props.formValue, 'caparre', '')
    ),
    'label'
  )
  const spese = _(constants.speseProps)
    .filter((item) =>
      _.includes(_.get(props.formValue, 'spese', ''), item.value)
    )
    .map((item) => item.label)
    .value()
  const tipoPagamento = _.get(
    _.find(
      constants.tipoSpese,
      (item) =>
        item.value === String(_.get(props.formValue, 'tipoPagamento', ''))
    ),
    'label'
  )
  const costoSpeseNonIncluse = _.toString(
    _.get(props.formValue, 'costoSpeseNonIncluse', '')
  ).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  const disdetta = _.get(
    _.find(
      constants.disdette,
      (item) => item.value === _.get(props.formValue, 'disdette', '')
    ),
    'label'
  )
  const animali = _.get(props.formValue, 'animali')
  return (
    <>
      <RowComponent
        testo={
          <Row>
            <Col span={24}>
              <span>
                Libero da{' '}
                <strong>{moment(libero).format('dddd D MMMM YYYY')}</strong>
              </span>
            </Col>
            <Col span={24}>
              <span>
                La permanenza minima è di <strong>{permanenza}</strong>
              </span>
            </Col>
          </Row>
        }
        onIconClick={() => props.goToStep(0, 2)}
      />
      <RowComponent
        testo={
          <Row>
            <Col span={24}>
              <span>
                Il canone mensile è di <strong>{canone},00</strong>
              </span>
            </Col>
            <Col span={24}>
              <span>
                <strong>{caparre} di caparra</strong> da anticipare
              </span>
            </Col>
          </Row>
        }
        onIconClick={() => props.goToStep(1, 2)}
      />
      <RowComponent
        testo={
          <Row>
            <Col span={24}>
              <span>
                Spese incluse <strong>{_.join(spese, ', ')}</strong>
              </span>
            </Col>
            <Col span={24}>
              <span>
                Per le spese non incluse nel canone viene richieste un{' '}
                <strong>{tipoPagamento}</strong>{' '}
                {costoSpeseNonIncluse && (
                  <span>
                    di <strong>{costoSpeseNonIncluse},00</strong>
                  </span>
                )}
              </span>
            </Col>
          </Row>
        }
        onIconClick={() => props.goToStep(1, 2)}
      />
      <RowComponent
        testo={
          <Row>
            <Col span={24}>
              <span>
                Il preavviso per la disdetta è di <strong>{disdetta}</strong>
              </span>
            </Col>
            <Col span={24}>
              {!animali ? (
                <span>
                  <strong>Non è permesso</strong> introdurre animali
                </span>
              ) : (
                <span>
                  <strong>È permesso</strong> introdurre animali
                </span>
              )}
            </Col>
          </Row>
        }
        onIconClick={() => props.goToStep(3, 2)}
      />
    </>
  )
}

export default RiepilogoCardCosti
